export type { VariantFilterAccordionProps } from './VariantFilterAccordion'
export { VariantFilterAccordion } from './VariantFilterAccordion'
